<template>
	<v-row
		justify = "center"
		align 	= "center"
	>
		<v-col
			xl 	 = "8"
			lg 	 = "10"
			md 	 = "10"
			sm 	 = "10"
			xs   = "12"
			cols = "12"
		>
			<v-card outlined>
				<v-card-title
					class = "body-2 secondary pa-1 white--text"
				>	
					<v-icon 
						small 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>
					<v-spacer></v-spacer>
					<v-icon
						x-small
						v-text = "'mdi-alarm'"
						class  = "mx-2"
						color  = "white"
					></v-icon>
					<span 
						v-text = "$ml.get('smart_event')"
					></span>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text
					class = "pa-1"
				>
					<v-row
						dense
					>
						<v-col 
							xl 	 = "2"
							lg 	 = "2"
							md 	 = "2"
							sm 	 = "3"
							xs 	 = "3"
							cols = "3"
							v-show = "show.add_smart"
							
						>
							<v-card >
								<v-card-title
									class = "pa-1 pl-1 secondary body-2 white--text"
								>
									<v-icon
										x-small
										color = "white"
										class = "mx-1"
									>
										mdi-form-select
									</v-icon>
									{{ $ml.get('options') }}
								</v-card-title>
								<v-card-text class = "pa-1 pt-0">
										
									<v-list dense>
										<v-list-item-group
										 	
										>
											<template
												v-for = "(btn_option, btn_index) of option_alarms"
												v-if  = "btn_option.enable"
											>	
												<v-card 
													outlined 
													:color = "btn_option.color"
													class  = "mt-1"
												>
												<v-list-item 
													:key   = "btn_index"	
													@click = "redirect(btn_option.btn_action, btn_option.key)"

												>
													<v-list-item-icon
													 		class = "mx-0"
													 	>
											            	<v-icon 
											            		small
											            		color  = "white"
											            		v-text = "btn_option.icon"
											          	></v-icon>
											        </v-list-item-icon>
													<v-list-item-title
														class  = "white--text"
														v-text = "btn_option.title"
													></v-list-item-title>
												</v-list-item>
											</v-card>
											</template>
										</v-list-item-group>
									</v-list>
								</v-card-text>
							</v-card>
						</v-col>
						<v-col>
							<v-toolbar
						    		
						    		dense
						    		height = "25"
						    		class  = "secondary white--text"
						    	>
						    	<v-toolbar-title 
						    		class = "body-2"
						    	>	
						    		<v-icon
										small
										color = "white"
										class = "ml-1"
									>
										mdi-view-list
									</v-icon>
									<span>										
						    			{{ $ml.get('registered_smart_event') }}
									</span>
						    		<!-- Registered Alarms -->
						    	</v-toolbar-title>
						    </v-toolbar>
								
							<v-divider></v-divider>
							<v-data-table
								dense
							    fixed-body
							    fixed-header
								:headers 			 = "header_table"
								:items 				 = "render_list"
								class 				 = "elevation-5"
								:options.sync 		 = "options"
							   	:server-items-length = "total"
							   	loading-text 		 = "Loading... Please wait"
							   	:loading 			 = "loading"
							    item-key 			 = "index"
							    :height 			 = "layout_height + 'px'"
							   	:footer-props 		 = "{
							   		showFirstLastPage 	: true,
							   		itemsPerPageOptions : [15, 30],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							>
							    <!-- rowsPerPageText: [30] -->
								<template v-slot:item.options = "{ item }" >
									<v-btn
										x-small
										color  = "primary"
										@click = "redirect('settings_alarm', item)"
										v-show = "show.edit_smart"
									>
										<v-icon
											x-small
											v-text = "'mdi-pencil'"
										></v-icon>
									</v-btn>	
									<v-btn
										x-small
										color  = "error"
										class  = "mx-1"
										@click = "actions('confirm_delete', item)"
										v-show = "show.delete_smart"
									>
										<v-icon
											x-small
											v-text  = "'mdi-delete'"
										></v-icon>
									</v-btn>							
								</template>
								<template v-slot:item.actions = "{ item }" >
									<v-btn
										x-small
										v-for  = "(item_btn, idx_btn) of item.actions"
										:key   = "idx_btn"
										:color = "item_btn.active ? 'primary' : 'secondary'"
										@click = "save_action(item_btn)"
										v-show = "show.edit_smart"
									>
										<v-icon
											x-small
										>
											{{ item_btn.icon }}
										</v-icon>
									</v-btn>
								</template>
								<template v-slot:item.analytic = "{ item }" >
										<!-- x-small -->
									<span  
										v-for = "(item_analytic, idx_analytic, key_analytic ) of item.analytic"
										:key  = "idx_analytic"
										v-if  = "idx_analytic < 2"
									>	
										
									 	{{ item_analytic.text + ', ' }}									 									
										{{ idx_analytic > 2 ?  ' ( ' + item_analytic.length - 2 + ')' : '' }} 
									</span>
								</template>
							</v-data-table>

						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
	import EventBus from '@/event-bus'

	export default {
		name: 'add_alarms',
		data: (vm) => ({
			info 		 : {},
			header_table : [
				{ text: vm.$ml.get('name'), value: 'name' },
				{ text: vm.$ml.get('count_device'), value: 'count_device' },
				{ text: vm.$ml.get('analytic'), value: 'analytic' },
				// { text: vm.$ml.get('actions'), value: 'actions' },
				// { text: vm.$ml.get('options'), value: 'options' },
				,
				// { text: vm.$ml.get('constellation'), value: 'constellation' },
			],
			options 		: { itemsPerPage: 30},
			total 			: 0,
			layout_height 	: 500,
			option_alarms 	: [
				{ 
					title: 'New alarm', 
					key: 'new',
					color: 'primary', 
					enable: true, 
					btn_action: 'settings_alarm', 
					icon 		: 'mdi-alarm-plus',
				},
				{ 
					title: 'Categories', 
					key: 'categiries',
					color: 'secondary', 
					enable: false, 
					btn_action: 'categories', 
				},
				{ 
					title: 'Access rules', 
					key: 'access_rules',
					color: 'secondary', 
					enable: false, 
					btn_action: 'access_rules', 
				},
			],
			list 	: [],
			loading : false,
			bus 	: {},
			show 	: {
				add_smart  		: false,
				edit_smart 		: true,
				delete_smart 	: true,
			},
			permission 	  : {
				"roles": [1, 2]
			},
		}), // data

		created(){
			// this.get_list();
			let modul = this.$store.getters["auth/permission"](this.$route.name || "smart_event", "", "smart_event");
			if (modul){ // this.$Helper.current_auth_user(this.currentUser, this.permission)
				if (modul.can_add) {					
					this.show.add_smart  = true; 
				}
				if (!modul.can_edit) {
					this.show.edit_smart = false;
				}
				if (!modul.can_delete) {
					this.show.delete_smart = false;
				}
				if (modul.can_edit || modul.can_delete) {					
					if (modul.can_edit) {
						this.header_table.push({ text: this.$ml.get('actions'), value: 'actions'});
					}
					this.header_table.push({ text: this.$ml.get('options'), value: 'options' });
				}
				// if (this.$router.currentRoute.name == 'device') {
				// }
			}
		}, // created

		watch:{
			options: {
				handler(){
					this.get_list();
				}, deep: true,
			}, // options

		}, // watch

		computed:{
			render_list: function(){
				return this.list;
			}, // render list
			currentUser(){
      			return this.$store.state.auth.user;      			
      		}, // currentUser
		}, // computed

		methods: {
			actions(act, item){
				if ( act == 'confirm_delete' ) {
					this.info = item;
					EventBus.$emit('notifications_modal', {
						type : 'confirm_delete',
						ID   :  'alarms',  
					})
				}
				if ( act == 'delete' ) {
					this.delete();
				}

			}, // actions

			get_list(){
				const { itemsPerPage, page } = this.options;
				let pg = 1, sw = 0;
				let vm = this;
				this.loading = true;

				if ( itemsPerPage == 15 ) {
					if (page % 2 == 0) {
						pg = (page/2);
						sw = 2;
					}else{
						pg = parseInt(page/2)+1;
						sw = 1;
					}
				}else{
					pg = page
				}
				const api = this.$URL + '/api/v1/alarm/?page='+pg;
				
				this.$axios.get(api).then( res => {
					console.log(res, 'Get list');
					let items  = res.data.rows;
					this.total = parseInt(res.data.count);
					if (items && items.length > 0) {		

						// this.$SmartEvent.set("list_smart_event", [ ...items], "delete_list", parseInt(res.data.page));

						if (itemsPerPage <= 15) {
							items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
						}
						items = this.render_list_smart(items);
						this.list = items;
						// this.save_local(items);
					}
					this.loading = false;

				}).catch( er => {
					console.log(er, 'Error get list');
					this.loading = false;
					/*if (er && er.message == 'Network Error') {
						EventBus.$emit('notifications_modal', {
							type : 'error',
							message : er.message 

						})
					}*/
					this.get_local();
				})
			}, // get list

			get_local(){
				let list_temp = [];
				if (localStorage.getItem('alarms')) {
					list_temp = JSON.parse(localStorage.getItem('alarms'));
					this.list = this.render_list_smart(list_temp);
				}else{
					console.log('Error get alarms');
				}
				// console.log(list_temp);
			}, // get local

			save_local(opt = false, item){
				let list_temp = [];
				if (localStorage.getItem('alarms')) {
					list_temp = JSON.parse(localStorage.getItem('alarms'));
				}
				if (opt) {
					let search = item;//this.info.id;
					list_temp.splice(list_temp.indexOf(search), 1);
				}
				localStorage.setItem('alarms', JSON.stringify(list_temp));				
			}, // save local

			delete(){
				let info_del = this.info;

				if (info_del && info_del.id) {
					const api = this.$URL + '/api/v1/alarm/' + info_del.id;

					this.$axios.delete( api ).then( res => {
						console.log(res, 'Delete res alarms');
						this.list.splice(this.list.indexOf(info_del), 1);
						this.total --;
						this.save_local(true, info_del);
						EventBus.$emit('notifications_modal', {
							type : 'deleted'
						});
					}).catch( er => {
						console.log(er, 'Error delete alarms');
					})
				}
			}, // delete

			redirect(url, item){
				if (url == 'settings_alarm') {
					console.log("clear alarms local ***************************************")
					localStorage.removeItem("settings_alarm");
					localStorage.removeItem("rule_alarm");
					localStorage.removeItem("device_alarm");
					localStorage.removeItem("action_alarm");
					localStorage.setItem("settings_alarm", JSON.stringify(item));
				}
				const  timer = setTimeout( () => {
					this.$router.push(url);
					clearTimeout(timer);
				}, 50)
			}, // redirect

			save_action(item){
				if (item && item.id) {
					let info_up = item.value;
					if (item.key) {
						info_up[item.key] = !item.active;
						item.active 	  = info_up[item.key]; 

					}
					const api = this.$URL + '/api/v1/alarm/action/' + item.id;
					this.$axios.put(api, info_up).then( res => {
						this.$EventBus.$emit("notifications_modal",{
							type 	: 'updated',
							message : this.$ml.get('actions')
						})
					}).catch( er => {
						console.log("Error update action ", er);
						this.$EventBus.$emit("notifications_modal",{
							type 	: 'error',
							message : er
						});
						if (item.key) {
							info_up[item.key] = !item.active;
							item.active 	  = info_up[item.key]; 

						}
					})
				}else{
					console.log("No found info  or property ID for update action");
					this.$EventBus.$emit("notifications_modal",{
						type 	: 'warning',
						message : this.$ml.get('not_found_propierties')
					});
				}
			}, // save action

			render_list_smart(items){
				if (items && items.length > 0) {
					let vm = this;
					items.forEach( (dev, idx_dev) => {
						if (dev.Detail_action_alarm && dev.Detail_action_alarm.length > 0) {
							dev.actions = 
								[{ 
									id 		: dev.Detail_action_alarm[0].id,
									key 	: "issound",
									value 	: dev.Detail_action_alarm[0],
									icon  	: "mdi-volume-high",
									active 	: dev.Detail_action_alarm[0].issound, 
								},
								{
									id 		: dev.Detail_action_alarm[0].id,								
									key 	: "ismodal", // popup
									value 	: dev.Detail_action_alarm[0],									
									icon 	: "mdi-message-alert",
									active 	: dev.Detail_action_alarm[0].ismodal, // popup
								}]
						}else {
							dev.actions = [
								{ 
									key 	: "issound",
									icon  	: "mdi-volume-high",
									active 	: false, 
								},
								{
									key 	: "ismodal", // popup
									icon 	: "mdi-message-alert",
									active 	: false,
								}
							]
						}
						if (dev.Detail_device_alarm && dev.Detail_device_alarm.length > 0) {
							console.log("DEVICES : ", dev.Detail_device_alarm);
							dev.count_device = 0;
							dev.Detail_device_alarm.forEach( (dev_count) =>{
								if (dev_count.state) {
									dev.count_device ++;
								}
							})
						}else{
							dev.count_device = 0;
						}
						dev.analytic  = [];	
						let text_temp = '';
						if (dev.Detail_rule_obj_alarm && dev.Detail_rule_obj_alarm.length > 0) {

							dev.Detail_rule_obj_alarm.forEach( (obj) =>{
								text_temp = obj.tag + ', ' + vm.$ml.get('minimum_time') + ': ' + obj.alertime + ', ' +
								vm.$ml.get('probability') + ': ' + obj.prob + '% , '+
								vm.$ml.get('capacity') + ': ' + obj.countag  


								let temp_detail = {
									text 		 : text_temp, 
									analytic 	 : obj.tag,
									minimum_time : obj.alertime,
									probability  : obj.prob + '%',
									capacity	 : obj.countag
								}								
								dev.analytic.push(temp_detail);
							})

						}
						if (dev.Detail_motion_alarm && dev.Detail_motion_alarm.length > 0) {
							text_temp 		= 'motion';
							let temp_detail = {
								text 	 : text_temp,
								analytic : 'motion'
							}
							dev.analytic.push(temp_detail);
						}
						if (dev.Detail_rule_face__alarm && dev.Detail_rule_face__alarm.length > 0) {
							text_temp = 'face';
							let temp_detail = {
								text 	 : text_temp,
								analytic : 'face'
							}
							dev.analytic.push(temp_detail);
						}
						if (dev.Detail_rule_lpr__alarm && dev.Detail_rule_lpr__alarm.length > 0) {
							text_temp = '';
							let tempLpr = dev.Detail_rule_lpr__alarm.filter(x=> x && x.type =='lpr');
							if (tempLpr.length > 0) {
								text_temp += 'lpr'
								let temp_detail = {
									text 	 : text_temp,
									analytic : 'lpr'
								}
								dev.analytic.push(temp_detail);
							}
							let tempParking = dev.Detail_rule_lpr__alarm.filter(x=> x && x.type =='parking');
							if (tempParking.length > 0) {
								text_temp += (text_temp?',': '') +'Parking';
								dev.analytic.push({text : text_temp, analytic:'parking'});

							}

						}
						if (dev.Detail_rule_action_alarm && dev.Detail_rule_action_alarm.length > 0) {
							
							text_temp = 'actions';
							let temp_detail = {
								text 	 : text_temp,
								analytic : 'actions'
							}
							dev.analytic.push(temp_detail);
						}
					});

					if (this.total === 0) {
						this.total = items.length === 1 ? 1 : items.length;
					}
					return items;

				}
				return [];
			}, // render list smart

		}, // methods


		mounted(){
			let temp_bus = 'notifications_modal' + 'alarms';
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					this.actions('delete');
				}
			})
		}, // mounted	

		beforeDestroy(){
			this.list = [];
			this.$Helper.clear_bus(EventBus, this.bus, 'add alarms(smart_event)');
		}, // before destroy
	};
</script>